import locationHelperBuilder from "redux-auth-wrapper/history4/locationHelper";
import { connectedRouterRedirect } from "redux-auth-wrapper/history4/redirect";
import { ROUTES } from "../configs/routes";
import { REQUEST_NUMBER } from "../constants/storage";
import { UtilsBrowser } from "../utils/UtilsBrowser";
import { Cookie } from "./storage";
import { AuthStatus } from "../types/user";
import { ApplicationState } from "../store";

const locationHelper = locationHelperBuilder({});

export const nonAuth = connectedRouterRedirect({
	authenticatedSelector: (state: ApplicationState) => {
		// Redirect to home if already authenticated
		return state.user.isAuthenticated !== AuthStatus.Authenticated;
	},
	redirectPath: (_, ownProps) => {
		return locationHelper.getRedirectQueryParam(ownProps) || ROUTES.ROOT;
	},
	wrapperDisplayName: "UserIsNotAuthenticated",
});

export const auth = connectedRouterRedirect({
	authenticatedSelector: (state: ApplicationState, ownProps: any) => {
		Cookie.remove(REQUEST_NUMBER);

		const isAuthenticated =
			state.user.isAuthenticated === AuthStatus.Authenticated;

		if (ownProps.match.params.requestNumber && !isAuthenticated) {
			Cookie.set(REQUEST_NUMBER, ownProps.match.params.requestNumber);
		}

		return isAuthenticated;
	},
	redirectPath: ROUTES.ROOT, // NOTE: Redirected back to home page so that user will be presented login options (email/SA)
	wrapperDisplayName: "UserIsAuthenticated",
});

export const unsupportedBrowserOnly = connectedRouterRedirect({
	authenticatedSelector: () => {
		return UtilsBrowser.isInternetExplorer();
	},
	redirectPath: ROUTES.ROOT,
});
